module.exports = __webpack_public_path__ + "img/sad--default.8854ce71.svg";